import type { ElementTextOptions } from 'core/types/element/element_text'
import optionsPropTypes from 'PropsSpec'

type Props = {
  options: ElementTextOptions
}

const Text = (props: Props) => {
  const { options } = props

  const styles = {
    width: '100%',
    paddingTop: options.padding_top,
    paddingRight: `${options.padding_right}px`,
    paddingBottom: `${options.padding_bottom}px`,
    paddingLeft: `${options.padding_left}px`,
    border: `${options.border_size}px ${options.border_style} rgba(${options.border_color})`,
    borderTop: options.border_side[0]
      ? `${options.border_size}px ${options.border_style} rgba(${options.border_color})`
      : 'none',
    borderRight: options.border_side[1]
      ? `${options.border_size}px ${options.border_style} rgba(${options.border_color})`
      : 'none',
    borderBottom: options.border_side[2]
      ? `${options.border_size}px ${options.border_style} rgba(${options.border_color})`
      : 'none',
    borderLeft: options.border_side[3]
      ? `${options.border_size}px ${options.border_style} rgba(${options.border_color})`
      : 'none',
    opacity: options.opacity,
    backgroundColor: `rgba(${options.bg_color})`,
    boxSizing: 'inherit'
  }

  const innerStyles = {
    color: `rgba(${options.text_color})`,
    textAlign: options.text_align,
    lineHeight: options.line_height,
    textTransform: `${options.text_transform}`,
    textDecoration: options.text_decoration,
    letterSpacing: options.letter_spacing,
    textShadow: options.text_shadow,
    fontFamily: options.font_family,
    fontSize: `${options.font_size}px`,
    fontWeight: options.font_weight,
    boxSizing: 'inherit'
  }

  return (
    <div className="wf_reset" style={styles}>
      <div dangerouslySetInnerHTML={{ __html: options.content }} style={innerStyles} />
    </div>
  )
}

Text.propTypes = {
  options: optionsPropTypes('text')
}

export default Text
